// UX-Vorschlag P1: Reihenfolge in „Mein Tag" per Ziehen. Reine Hilfsfunktion
// fuer die optimistische Anzeige, bis der Store neu geladen ist.

/**
 * Ordnet `items` nach `order` (entry_ids). Eintraege, die `order` nicht kennt
 * (z. B. inzwischen neu hinzugekommen), bleiben in ihrer Reihenfolge hinten.
 */
export function applyReorder<T extends { entry_id: number }>(items: T[], order: number[]): T[] {
  const pos = new Map(order.map((id, i) => [id, i] as const));
  const known = items.filter((i) => pos.has(i.entry_id));
  const unknown = items.filter((i) => !pos.has(i.entry_id));
  known.sort((a, b) => pos.get(a.entry_id)! - pos.get(b.entry_id)!);
  return [...known, ...unknown];
}
